import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { Calendar, ChevronRight, FolderOpen } from "lucide-react";
import { listarProjetosCliente, ProjetoCliente } from "../../services/clientePortal";

const STATUS_LABELS: Record<string, string> = {
  planejamento: "Em planejamento",
  ativo: "Em andamento",
  pausado: "Pausado",
  entregue: "Entregue",
};

const STATUS_BADGE: Record<string, string> = {
  planejamento: "bg-slate-100 text-slate-700",
  ativo: "bg-blue-100 text-blue-700",
  pausado: "bg-amber-100 text-amber-700",
  entregue: "bg-emerald-100 text-emerald-700",
};

export function ClienteProjetos() {
  const { data: projetos = [], isLoading } = useQuery({ queryKey: ["cliente-projetos"], queryFn: listarProjetosCliente });

  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-xl font-bold text-slate-800">Seus projetos</h1>
        <p className="text-sm text-slate-500 mt-0.5">Acompanhe o andamento dos seus projetos.</p>
      </div>

      {isLoading && <p className="text-sm text-slate-400">Carregando…</p>}
      {!isLoading && projetos.length === 0 && (
        <div className="bg-white border border-slate-200 rounded-xl p-8 text-center">
          <FolderOpen size={32} className="mx-auto text-slate-300 mb-2" />
          <p className="text-sm text-slate-500">Você ainda não tem projetos vinculados.</p>
        </div>
      )}

      <div className="grid gap-3">
        {projetos.map((p) => <ProjetoCard key={p.id} p={p} />)}
      </div>
    </div>
  );
}

function ProjetoCard({ p }: { p: ProjetoCliente }) {
  return (
    <Link
      to={`/cliente/projetos/${p.id}`}
      className="bg-white border border-slate-200 rounded-xl p-4 hover:border-blue-400 hover:shadow-sm transition-all flex items-center gap-4"
    >
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <h3 className="font-semibold text-slate-800 truncate">{p.nome}</h3>
          <span className={`text-[10px] uppercase font-bold px-2 py-0.5 rounded ${STATUS_BADGE[p.status] || "bg-slate-100 text-slate-600"}`}>
            {STATUS_LABELS[p.status] || p.status}
          </span>
        </div>
        {p.resumoPublico && <p className="text-sm text-slate-500 mt-1 line-clamp-2">{p.resumoPublico}</p>}
        <div className="flex items-center gap-4 mt-2 text-xs text-slate-500">
          <span className="flex items-center gap-1">
            <Calendar size={11} />
            Entrega prevista: {new Date(p.prazoEntrega).toLocaleDateString("pt-BR")}
          </span>
          <span>{p.tarefasConcluidas}/{p.tarefasVisiveis} entregas</span>
          <span>{p.marcosConcluidos}/{p.marcos} marcos</span>
        </div>
        <div className="mt-3 h-1.5 bg-slate-100 rounded-full overflow-hidden">
          <div className="h-full bg-blue-500 transition-all" style={{ width: `${p.progresso}%` }} />
        </div>
        <p className="text-[11px] text-slate-500 mt-1">Progresso: {p.progresso}%</p>
      </div>
      <ChevronRight size={20} className="text-slate-300 shrink-0" />
    </Link>
  );
}
